<template>
	<div class="module-manage-root pa-0 d-flex flex-column">
		<div flat class="flex-grow-0 flex-shrink-0 mt-2 d-flex flex-row">
			<div class="form-item form-item-width-3 mb-1">
				<label class="form-item-label mt-1 mr-1">选择模块:</label>
				<div class="form-item-value" style="position:relative;height:100%">
					<div style="position:absolute;top:0;bottom:0;left:0;right:0;">
						<v-select v-model="selectedModule" :items="modules" label="" hide-details flat solo outlined dense return-object
						 item-text="caption" full-width>
						</v-select>
					</div>
				</div>

			</div>

			<v-btn class="ml-2 mb-2 right-round" @click="handleApplyFilter" color="primary" :disabled="btnLoaderModuleFuncDisabled">
				<v-icon>mdi-file-find</v-icon>
				加载
			</v-btn>

			<v-btn class="ml-2 mb-2 left-round" color="info" @click="handleAddLower" :disabled="btnAddLowerDisabled">
				<span>
					<v-icon>mdi-file-outline</v-icon>
				</span>
				增加下级
			</v-btn>

			<v-btn class="ml-2 mb-2 right-round" color="info" :disabled="btnAddSameLevelDisabled" @click="handleAddSameLevel">
				<span>
					<v-icon>mdi-file-outline</v-icon>
				</span>
				增加同级
			</v-btn>

			<v-btn rounded class="ml-2 mb-2" color="info" :disabled="btnEditDisabled" @click="handleEdit">
				<span>
					<v-icon>mdi-notebook-edit-outline</v-icon>
				</span>
				编辑
			</v-btn>

			<v-btn rounded class="ml-4 mb-2 mr-4" color="blue-grey" @click="handleDeleteFunc" :disabled="btnDeleteDisabled">
				<span>
					<v-icon>mdi-note-remove-outline</v-icon>
				</span>
				删除
			</v-btn>


		</div>
		<div class="flex-grow-1 flex-shrink-1" style="position:relative;">
			<div style="position:absolute;top:0;bottom:0;left:0;right:0;" class="pa-1">
				<v-data-table :headers="headers" dense fixed-header :items="visibleModuleFunctions" class="elevation-1 module-function-table"
				 disable-pagination hide-default-footer height="100%" width="100%" single-select show-select item-key="moduleFuncId"
				 v-model="selectedModuleFunc"
				 calculate-widths
				 >
					<template v-slot:item.moduleFuncCode="{ item }">
						<v-container>
							<v-row>
								<v-col>
									<span v-for="n in item.level-1" :key="n"> &emsp;</span>
									<v-icon v-if="canOpen(item)" v-on:click="openFunc(item)">mdi-plus-box-outline</v-icon>
									<v-icon v-else-if="canClose(item)" v-on:click="closeFunc(item)">mdi-minus-box-outline</v-icon>
									<v-icon v-else>mdi-border-none-variant</v-icon>
									{{ item.moduleFuncCode}}
								</v-col>
							</v-row>
						</v-container>
					</template>
				</v-data-table>
			</div>
		</div>
		<edit-module-func-dialog 
			ref="editModuleFuncDialog" 
			v-on:moduleFunctionAdded="moduleFunctionAdded"
			v-on:moduleFunctionUpdated="moduleFunctionUpdated">
		</edit-module-func-dialog>
	</div>

</template>

<script>
	import {default as ModuleApi} from "../../../../api/smp/sys/ModuleApi.js";
	import {default as ModuleFunctionApi} from "../../../../api/smp/sys/ModuleFunctionApi.js";
	import ModuleFuncEditDialog from './ModuleFuncEditDialog.vue';

	export default {
		name: 'Smp-Module-Function-Manage',
		components: {
			'edit-module-func-dialog': ModuleFuncEditDialog,
		},
		data: () => ({
			headers: [

				{
					text: '代码',
					value: 'moduleFuncCode',
					sortable: false,
					width: 400,
					divider: true
				},
				{
					text: '编号',
					align: 'start',
					sortable: false,
					value: 'moduleFuncId',
					width: 40,
					divider: true
				},
				{
					text: '名称',
					value: 'moduleFuncName',
					sortable: false,
					width: 200,
					divider: true
				},
				{
					text: '类型',
					value: 'typeName',
					sortable: false,
					width: 200,
					divider: true
				},
				{
					text: '方法',
					value: 'methodName',
					sortable: false,
					width: 100,
					divider: true
				},
				{
					text: '路径',
					value: 'path',
					sortable: false,
					width: 300,
					divider: true
                },
                {
					text: '路由名',
					value: 'routeName',
					sortable: false,
					width: 300,
					divider: true
				},
        {
          text: '网页类型',
          value: 'webpageTypeName',
          sortable: false,
          width: 100,
          divider: true
        },

			],
			modules: [],
			moduleFunctions: [],
			visibleModuleFunctions: [],
			selectedModule: null,
			selectedModuleFunc: [],
			moduleFuncCodeMap: new Map(),
			moduleFuncIdMap: new Map()
		}),
		methods: {
			moduleFunctionAdded(added) {
				let me =this;
				console.log("added");
				console.log(added);
				if(added.moduleFuncCode.length==4){
					added.higher = null;
					added.level = 1;
					added.opened = false;
					added.lower=[];
					me.moduleFunctions.push(added);
				}else{
					let parentCode = added.moduleFuncCode.substr(0,added.moduleFuncCode.length-4);
					let parentModuleFunc = me.moduleFuncCodeMap.get(parentCode);
					if(parentModuleFunc){
						added.higher = parentModuleFunc;
						added.level = parentModuleFunc.level+1;
						added.opened = false;
						added.lower=[];
						parentModuleFunc.lower.push(added);
					}
				}
				me.moduleFuncCodeMap.set(added.moduleFuncCode,added);
				me.moduleFuncIdMap.set(added.moduleFuncId,added);
				me.collectVisibleFuncs();
			},
			moduleFunctionUpdated(updated) {
				console.log("updated to");
				console.log(updated);
				let moduleFunc = this.moduleFuncIdMap.get(updated.moduleFuncId);
				console.log("update old:");
				console.log(moduleFunc);
				moduleFunc.moduleFuncCode=updated.moduleFuncCode;
				moduleFunc.moduleFuncName=updated.moduleFuncName;
				moduleFunc.path=updated.path;
				moduleFunc.methodId=updated.methodId;
				moduleFunc.methodName=updated.methodName;
				moduleFunc.typeId=updated.typeId;
				moduleFunc.typeName=updated.typeName;
				moduleFunc.webpageTypeId=updated.webpageTypeId;
				moduleFunc.webpageTypeName = updated.webpageTypeName;
				moduleFunc.routeName=updated.routeName;
			},
			handleApplyFilter() {
				this.loadModuleFunctions();
			},
			handleAddLower() {
				let dialog = this.$refs.editModuleFuncDialog;
				dialog.setMode(1);
				dialog.setHigher(this.selectedModuleFunc[0]);
				dialog.setVisible(true);
			},
			handleAddSameLevel() {
				let dialog = this.$refs.editModuleFuncDialog;
				dialog.setMode(2);
				dialog.setSameLevel(this.selectedModuleFunc[0]);
				dialog.setVisible(true);
			},
			handleEdit() {
				let dialog = this.$refs.editModuleFuncDialog;
				dialog.setMode(3);
				dialog.setEdit(this.selectedModuleFunc[0]);
				dialog.setVisible(true);
			},
			getItemText(item) {
				console.log("getting item text");
				console.log(item);
			},
			async errMsg(title, text) {
				await this.$dialog.error({
					text: text,
					title: title
				});
			},
			loadModules() {
				let me = this;
				ModuleApi.queryAllModule().then(function(resp) {
					let data = resp.data;
					if ((!data) || (!(data.code)) || (data.code != 200) || (!data.data)) {
						let msg = data.msg;
						msg = ((!msg) || (msg == '')) ? '获取模块信息失败' : msg;
						throw new Error(msg);
						return;
					}

					let modules = data.data.modules;
					//修改类型名
					modules.forEach(function(module) {
						module.caption = module.moduleId + " - " + module.moduleCode + " - " + module.moduleName;
					});
					me.modules = modules;
				}).catch(function(err) {
					me.errMsg('错误', '获取模块信息失败:' + err.message);
				});
			},
			loadModuleFunctions() {
				let me = this;
				if (!me.selectedModule)
					return;
				ModuleFunctionApi.queryByModuleId(me.selectedModule.moduleId).then(function(resp) {
					let data = resp.data;
					if ((!data) || (!(data.code)) || (data.code != 200) || (!data.data)) {
						let msg = data.msg;
						msg = ((!msg) || (msg == '')) ? '获取模块功能信息失败' : msg;
						throw new Error(msg);
						return;
					}

					let moduleFunctions = data.data.moduleFunctions;

					moduleFunctions = me.genTree(moduleFunctions);

					me.levelModuleFunctions(moduleFunctions, 1, null);
					me.moduleFunctions = moduleFunctions;
					me.collectVisibleFuncs();
				}).catch(function(err) {
					console.log(err.stack);
					me.errMsg('错误', '获取模块功能信息失败:' + err.message);
				});
			},
			genTree(moduleFunctions) {
				let lenPerLevel = 4;
				let me = this;
				let result = [];
				let map = this.moduleFuncCodeMap;
				let idMap = this.moduleFuncIdMap;
				map.clear();
				idMap.clear();
				let orderedFunc = moduleFunctions.sort(me.compareFunc);
				//let orderedFunc = moduleFunctions;
				orderedFunc.forEach(function(item) {
					idMap.set(item.moduleFuncId, item);
					let code = item.moduleFuncCode;
					item.lower = [];
					if (code.length == 1 * lenPerLevel)
						result.push(item);
					else {
						let parentItem = map.get(code.substr(0, code.length - 1 * lenPerLevel));
						if (parentItem) {
							parentItem.lower.push(item);
						}
					}
					map.set(code, item);
				});
				return result;
			},
			compareFunc(func1, func2) {
				//console.log(func1.moduleFuncCode+"-"+func2.moduleFuncCode);
				let res = 0;
				if (func1.moduleFuncCode.length < func2.moduleFuncCode.length)
					res = -1;
				else if (func1.moduleFuncCode < func2.moduleFuncCode)
					res = -1;
				else
					res = 1;

				//console.log(res);
				return res;

			},
			levelModuleFunctions(moduleFunctions, level, higherModuleFunction) {
				let me = this;

				moduleFunctions.forEach(function(item) {
					me.moduleFunctions.push(item);
					item.higher = higherModuleFunction;
					item.level = level;
					item.opened = false;
					if (item.lower)
						me.levelModuleFunctions(item.lower, level + 1, item);

				});
			},
			canOpen(func) {
				return this.hasLower(func) && (!func.opened);
			},
			canClose(func) {
				return this.hasLower(func) && (func.opened);
			},
			hasLower(func) {
				return func && func.lower && func.lower.length && func.lower.length > 0;
			},
			openFunc(func) {
				func.opened = true;
				this.collectVisibleFuncs();
			},
			closeFunc(func) {
				func.opened = false;
				this.collectVisibleFuncs();
			},
			funcVisible(func) {
				if (!func.higher)
					return true;
				return func.higher.opened;
			},
			collectVisibleFunc(visible, func) {
				let me = this;
				if (me.funcVisible(func)) {
					visible.push(func);
					if (func.lower) {
						func.lower.forEach(function(item) {
							me.collectVisibleFunc(visible, item);
						});
					}
				}
			},
			collectVisibleFuncs() {
				let visible = [];
				let me = this;
				me.moduleFunctions.forEach(function(item) {
					me.collectVisibleFunc(visible, item);
				});

				me.visibleModuleFunctions = visible;
			},

			handleDeleteFunc() {
				let me = this;
				me.errMsg('错误', '暂不支持此操作');
			}

		},
		computed: {
			btnLoaderModuleFuncDisabled() {
				return !this.selectedModule;
			},
			btnAddLowerDisabled() {
				return !this.selectedModuleFunc ||
					((this.selectedModuleFunc instanceof Array) && (this.selectedModuleFunc.length < 1));
			},
			btnAddSameLevelDisabled() {
				return !this.selectedModuleFunc ||
					((this.selectedModuleFunc instanceof Array) && (this.selectedModuleFunc.length < 1));
			},
			btnAddHigherDisabled() {
				return !this.selectedModuleFunc ||
					((this.selectedModuleFunc instanceof Array) && (this.selectedModuleFunc.length < 1));
			},
			btnEditDisabled() {
				return !this.selectedModuleFunc ||
					((this.selectedModuleFunc instanceof Array) && (this.selectedModuleFunc.length < 1));
			},
			btnDeleteDisabled() {
				return !this.selectedModuleFunc ||
					((this.selectedModuleFunc instanceof Array) && (this.selectedModuleFunc.length < 1));
			},
		},
		created() {
			this.loadModules();
		}
	}
</script>

<style scoped>
	.module-manage-root {
		max-width: 100%;
		max-height: 100%;
		width: 100%;
		height: 100%;
	}

	.module-function-table {
		width: 100%;
		height: 100%;
		max-width: 100%;
		max-height: 100%;
	}

	.maxed {
		width: 100%;
		height: 100%;
		max-width: 100%;
		max-height: 100%;
	}
</style>
